<template>
  <div>
    <section class="content cleafix" v-if="step === 1">
      <form>
        <h1 class="form-head">
          用户初始化
        </h1>
        <div class="form-body">
          <div class="input-item show-info">
            <span class="label">姓名:</span>
            <span class="email">{{realname}}</span>
          </div>
          <div class="input-item show-info">
            <div class="col-xs-3">
              <div class="row">
                <span class="label">用户名:</span>
              </div>
            </div>
            <select name="username" id="" class="input col-xs-9">
              <option :value="un" v-for="un in usernames" :key="un">{{un}}</option>
            </select>
          </div>
          <div class="input-item clearfix">
            <div class="col-xs-12 clearfix">
              <div class="row clearfix">
                <div class="col-sm-7 n-p-l">
                  <input type="text" class="input" v-model.trim="verifyCode" placeholder="验证码" @blur="validateCode()">
                </div>
                <div class="col-sm-5 n-p-r n-p-l">
                  <button type="button" class="btn btn-md btn-primary col-xs-12" :disabled="reset.disabled" @click="sendVerifyCode()">{{reset.text}}</button>
                </div>
              </div>
              <div class="row">
                <span class="input-tips">{{error.code}}</span>
              </div>
            </div>
          </div>
          <div class="input-item">
            <input type="text" class="input" name="nickname" placeholder="昵称:风清扬" required="required" v-model.trim="nickname" autocomplete="off">
            <span class="input-tips">{{error.nickname}}</span>
          </div>
          <div class="input-item">
            <input type="password" class="input" name="password" placeholder="密码：6-16位字符、数字、特殊字符" required="required" v-model.trim="password" autocomplete="off">
          </div>
          <div class="input-item">
            <input type="password" class="input" name="rpassword" placeholder="再次输入：6-16位字符、数字、特殊字符" required="required" v-model.trim="rpassword" autocomplete="off">
            <span class="input-tips">{{error.password}}</span>
          </div>
          <div class="input-item">
            <input type="button" class="btn btn-primary btn-md col-xs-12" value="初始化用户" @click="registerFunc()">
          </div>
        </div>
      </form>
    </section>
    <!-- / register end /-->
    <section class="content" v-if="step === 2">
      <div class="init-content">
        <div class="step-content">
          <form v-if="category === 1" class="company-info">
            <h1 class="form-head">完善个人信息</h1>
            <div class="input-item n-m-b">
              <div class="logo">
                <img :alt="user.nickname" :src="user.avatar">
                <input type="file" class="hidden-file" name="file" accept="image/*" @change="uploadAvatar($event)">
              </div>
            </div>
            <div class="input-item show-info text-center">
              <span class="email">{{user.nickname}}</span>
            </div>
            <div class="input-item">
              <input type="text" class="input" placeholder="真实姓名：华宇互联" required="required" v-model.trim="user.realname" autocomplete="off" readonly="readonly" disabled="disabled">
            </div>
            <div class="input-item">
              <input type="text" class="input" placeholder="QQ：10000" required="required" v-model.trim="user.qq" autocomplete="off">
            </div>
            <div class="input-item">
              <textarea class="input textarea" resize="none" placeholder="个性签名：人在江湖飘，就是要挨刀！" required="required" v-model.trim="user.signature" autocomplete="off"></textarea>
            </div>
            <div class="input-item">
              <input type="button" class="btn btn-md btn-primary col-xs-12" value="完善信息，开始测评" @click="completeInfo()">
            </div>
          </form>
          <!-- / user end -->
        </div>
      </div>
    </section>
    <!-- / register end /-->
  </div>
</template>
<script>
let emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
let codeReg = /^[a-z0-9A-Z]{6}$/;
import WebUploader from "webuploader";
import Auth from "../../resource/auth";
export default {
  data: function() {
    return {
      code: "",
      category: 1,
      username: "",
      usernames: [],
      realname: "",
      email: "",
      phone: "",
      password: "",
      nickname: "",
      rpassword: "",
      companyName: "",
      verifyCode: "",
      error: {
        email: "",
        password: "",
        code: "",
        nickname: ""
      },
      validate: [0, 0],
      step: 1,
      reset: {
        text: "发送验证码",
        disabled: false,
        timer: null,
        seconds: 60
      },
      register: {
        disabled: true,
        validate: [0, 0]
      },
      user: {
        nickname: "",
        realname: "",
        avatar: "/assets/images/default-user-avatar.png",
        qq: "",
        signature: ""
      },
      uploader: null
    };
  },
  computed: {
    validateFlag: function() {
      const that = this;
      let tmp = that.validate.join("");
      return tmp;
    }
  },
  created: function() {
    const that = this;
    document.title = `用户初始化|${that.global.name}`;
    that.code = that.$route.params.code; // code
    that.loadInfo();
  },
  watch: {
    password: function(now, pre) {
      const that = this;
      if (now !== pre) {
        that.register.validate[1] = 0;
      }
      if (that.password === "" || that.rpassword === "") {
        that.register.validate[1] = 0;
        that.error.password = "";
        return;
      }
      if (!that.global.regex.password.test(that.password)) {
        that.register.validate[1] = 0;
        that.error.password = "格式错误：6-16位字符、数字、特殊字符至少包含两种";
        return;
      }
      if (that.password === that.rpassword) {
        that.register.validate[1] = 1;
        that.error.password = "";
        that.register.disabled = that.register.validate.join("") !== "11";
      } else {
        that.register.validate[1] = 0;
        that.error.password = "两次输入的密码不一致";
      }
    },
    rpassword: function(now, pre) {
      const that = this;
      if (now !== pre) {
        that.register.validate[1] = 0;
      }
      if (that.password === "" || that.rpassword === "") {
        that.register.validate[1] = 0;
        that.error.password = "";
        return;
      }
      if (!that.global.regex.password.test(that.rpassword)) {
        that.register.validate[1] = 0;
        that.error.password = "格式错误：6-16位字符、数字、特殊字符至少包含两种";
        return;
      }
      if (that.password === that.rpassword) {
        that.register.validate[1] = 1;
        that.error.password = "";
        that.register.disabled = that.register.validate.join("") !== "11";
      } else {
        that.register.validate[1] = 0;
        that.error.password = "两次输入的密码不一致";
      }
    }
  },
  methods: {
    loadInfo: function() {
      const that = this;
      Auth.initializeInfo({ code: that.code }).then(res => {
        const data = res.data;
        const rs = data.result;
        if (data.code === 0) {
          if (rs.email) {
            that.usernames.push(rs.email);
          }
          if (rs.phone) {
            that.usernames.push(rs.phone);
          }
          that.username = that.usernames[0];
          that.realname = rs.realname;
          that.nickname = rs.realname;
        } else {
          that.$router.replace({
            name: "/auth/login",
            query: { username: rs ? rs.email || rs.phone : "" }
          });
        }
      });
    },
    sendVerifyCode: function() {
      const that = this;
      that.reset.disabled = true; // 禁用按钮
      Auth.sendVerifyCode({ username: that.username }).then(res => {
        const data = res.body;
        if (data.code === 0) {
          // 校验成功
          that.reset.seconds = 60;
          that.reset.text = `剩余，${that.reset.seconds}s`;
          that.reset.timer = setInterval(() => {
            // 倒计时
            if (that.reset.seconds === 0) {
              that.reset.disabled = false;
              that.reset.text = `重发验证码`;
              clearInterval(that.reset.timer);
              that.reset.timer = null;
            } else {
              that.reset.seconds--;
              that.reset.text = `剩余，${that.reset.seconds} s`;
            }
          }, 1000);
        } else {
          that.reset.disabled = false;
          alert(data.msg);
        }
      });
    },
    validateCode: function() {
      const that = this;
      if (that.verifyCode == "") {
        that.register.disabled = true;
        that.register.validate[0] = 0;
        that.error.code = "请输入验证码";
        return;
      }
      if (codeReg.test(that.verifyCode)) {
        that.error.code = "";
        that.register.validate[0] = 1;
        that.register.disabled = that.register.validate.join("") !== "11";
      } else {
        that.error.code = "请输入正确的验证码";
        that.register.validate[0] = 0;
        that.register.disabled = true;
      }
    },
    registerFunc: function() {
      const that = this;
      if (that.register.disabled) {
        alert("请填写完成验证信息后，再进行下一步操作");
        return;
      }
      if (!that.nickname) {
        that.error.nickname = "请输入昵称";
        return;
      }
      that.error.nickname = "";
      that.register.disabled = true;
      let user = {
        phone: that.phone,
        email: that.email,
        password: that.password,
        category: that.category,
        verifyCode: that.verifyCode,
        nickname: that.nickname,
        username: that.username
      };
      Auth.userRegister({}, user).then(res => {
        if (res.status === 200) {
          let data = res.body;
          if (data.code === 0) {
            // 校验成功
            that.register.disabled = true;
            that.step = 2;
            that.uploader = WebUploader.create({
              auto: true,
              server: "/api/upload",
              pick: {
                multiple: false
              },
              accept: {
                title: "Images",
                extensions: "gif,jpg,jpeg,bmp,png",
                mimeTypes: "image/*"
              },
              formData: {}
            });
          } else {
            that.register.disabled = false;
            alert(data.msg);
          }
        } else {
          alert("服务器繁忙，请稍后再重试注册(╯﹏╰）!!!");
        }
      });
    },
    uploadAvatar: function(event) {
      const that = this;
      that.uploader.on("uploadSuccess", (file, res) => {
        if (res.code === 0) {
          that.user.avatar = res.result.url;
        } else {
          alert(res.msg);
        }
      });
      that.uploader.addFile(event.target.files[0]);
    },
    skipComplete: function() {
      const that = this;
      that.$router.replace({
        name: "EvaluateShow",
        params: { code: that.$route.params.code }
      });
    },
    completeInfo: function() {
      const that = this;
      that.$http.put("/api/v1/users/", that.user).then(
        res => {
          if (res.status === 200) {
            let data = res.body;
            if (data.code === 0) {
              // 校验成功
              that.$router.replace({
                name: "EvaluateShow",
                params: { code: that.$route.params.code }
              });
            } else {
              alert(data.msg);
            }
          } else {
            alert("服务器繁忙，请稍后再重试注册(╯﹏╰）!!!");
          }
        },
        res => {
          alert("服务器繁忙，请稍后再重试注册(╯﹏╰）!!!");
        }
      );
    }
  }
};
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// initialize.vue?4f7b78ee